<template>
  <div>
    <b-card>
      <div class="tree-container">
        <faultTree
          v-if="loaded"
          class="fault-tree"
          :editable="false"
          :data="treeData"
          :getTree="getTree"
          :filter="filter"
          @updateTree="updateTree($event)"
          @nodeDbClick="setPath($event)"
        ></faultTree>
        <span v-else>
          <p>{{$t('loadinfFaultTreeMessage')}}</p>
        </span>
      </div>
    </b-card>

    <div class="selected-reason mt-3">
      <label>Motivo Selecionado: <span>{{ path }}</span></label>
    </div>

    <div class="other-reason mt-3" v-if="isOtherReason">
      <textarea
        :disabled="!path"
        name="other"
        :placeholder="$t('placeholderReasons')"
        id="other"
        rows="2"
        v-model="otherDescritption"
      ></textarea>
    </div>

    <div class="button-container">
      <button class="btn btn-secondary" @click="$bvModal.hide('faultTreeSelect')">
        Cancelar
      </button>
      <button 
        class="btn btn-primary" 
        :disabled="!path"
        @click="apply">
        Adicionar
      </button>
    </div>
  </div>
</template>

<script>
import FaultTree from "../manageOccurrenceHandling/template/FaultTree.vue";
import { faultTreeMixin } from "../mixins/faultTreeMixin";
import { urlMainAPI } from "@/global";
import axios from "axios";

export default {
  name: "FaulTreeSelect",

  components: { FaultTree },

  mixins: [faultTreeMixin],

  inject: ["getIndicatorSelected"],

  props: ["result", "isActionTree"],

  data() {
    return {
      otherDescritption: "",
      treeDataSelected: [],
      path: "",
      nodeSelected: "",
      loaded: false,
      filter: "",
    };
  },

  computed: {
    isOtherReason() {
      return this.nodeSelected && 
             this.nodeSelected.node && 
             this.nodeSelected.node.data && 
             (this.nodeSelected.node.data.text.toLowerCase() === 'outros' || 
              this.nodeSelected.node.data.text.toLowerCase() === 'outro' || 
              this.nodeSelected.node.data.text.toLowerCase().includes('outro'));
    }
  },

  methods: {
    async setActionTree(data){
      await axios
        .get(`${urlMainAPI}/getdecisiontree/${data.id}/${data.productionUnitId}/${data.system}/${data.faulTreeId}`)
        .then((res) => {
          if (res.data) {
            this.treeData = this.copyFrom(res.data);
            this.treeDataBkp = this.copyFrom(res.data);
            this.reloadTree = false;
          }
        })
        .catch(console.log);
    },
    async setFaulTree(data){
      this.loaded = false;
      await axios
        .get(`${urlMainAPI}/getfaulttree/${data.id}/${data.productionUnitId}/${data.system}`)
        .then((res) => {
          if (res.data) {
            this.treeData = this.copyFrom(res.data);
            this.treeDataBkp = this.copyFrom(res.data);
            this.loaded = true;
          }
        })
        .catch((err) => {
          console.error("Erro ao carregar árvore de falhas:", err);
          this.loaded = true;
        });
    },

    setPath(obj) {
      this.nodeSelected = obj;
      this.path = obj.path;
      
      // Se não for "Outros", limpa a descrição
      if (!this.isOtherReason) {
        this.otherDescritption = "";
      }
    },

    apply() {
      this.nodeSelected.path +=
        this.otherDescritption != "" && this.isOtherReason
          ? ` > Outros: ${this.otherDescritption}`
          : ``;
      this.$emit("result", this.nodeSelected, this.isActionTree);
      this.$bvModal.hide("faultTreeSelect");
    },

    async loadFaultTree() {
      await axios
        .get(`${urlMainAPI}/getfaulttreeconfiguration`)
        .then((res) => {
          if (res.data) {
            this.treeData = this.copyFrom(res.data.faultTree);
            this.treeDataBkp = this.copyFrom(res.data.faultTree);
            this.indicators = this.formatIndicator(res.data.indicatorList);
            this.options = this.formatSelect(res.data.indicatorList);
            this.loaded = true;
          }
        })
        .catch(console.log);
    },

    formatSelect(data) {
      let newList = new Array();
      data.forEach((i) => {
        let hasData = newList.find(
          (n) => n.id == i.id && n.productionUnitId == i.productionUnitId
        );
        if (!hasData) {
          newList.push({
            value: {
              id: i.id,
              productionUnitId: i.productionUnitId,
              system: i.system,
            },
            text: i.indicatorName,
          });
        }
      });
      return newList;
    },
  },

  created() {
    this.loadFaultTree();
  },
};
</script>

<style scoped>
.tree-container {
  max-height: 300px;
  overflow-y: auto;
}

.selected-reason {
  margin-top: 1rem;
}

.selected-reason label {
  font-weight: bold;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 4px;
}

.selected-reason span {
  font-weight: normal;
}

.other-reason textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
}

.btn-primary {
  background-color: #ff5f00;
  border-color: #ff5f00;
}

.btn-primary:hover {
  background-color: #e65600;
  border-color: #e65600;
}

.btn-primary:disabled {
  background-color: #ffa366;
  border-color: #ffa366;
}

.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
}

.fault-tree {
  min-height: 200px;
}
</style>